import React from 'react';
import { Plus } from '../../../components/icons';

import styles from './empty-contact.module.scss';
type EmptyContactProps = {
  contactName: string;
  onClick: () => void;
};

export const EmptyContact: React.FC<EmptyContactProps> = ({ contactName, onClick }) => (
  <div className={styles['container']} onClick={onClick}>
    <div className={styles['icon']}>
      <Plus />
    </div>

    <p className={styles['text']}>{`Choose ${contactName}`}</p>
  </div>
);
